<template>
  <div>
    <div class="d-flex col-12 justify-content-end p-0">
      <div class="col-lg-5 col-5 px-2 pt-2 transaction">
        <v-select
          v-model="filters.date"
          :reduce="(draw) => draw.data"
          label="label"
          :options="dateOptions"
        ></v-select>
      </div>
      <div class="pt-1">
        <button
          type="button"
          class="btn btn-primary mt-4 ml-1"
          style="flex-shrink: 0"
          @click="
            filters.page = 1;
          fetchUserWithdraws();
          "
        >
          {{ $t("transaction.all") }}
          {{ $t("transaction.search") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex justify-content-center mx-auto my-5"
      v-if="isWithdrawsFetching"
    >
      <Loading
        color="#000000"
        size="24"
        class="px-4 py-0"
      />
      <span> Loading ... </span>
    </div>
    <div
      class="mx-auto my-5"
      v-else-if="withdraws.length === 0"
    >
      <h3 class="text-center">No Withdraws Found</h3>
    </div>
    <table
      class="table align-items-center table-custom pt-3"
      v-else
    >
      <thead style="background: #282a31; border: none">
        <tr>
          <th>{{ $t("voucher.total_amount") }}</th>
          <th>{{ $t("transaction.status") }}</th>
          <th>form တင်သည့် အချိန်</th>
          <th></th>
        </tr>
      </thead>
      <tbody class="list">
        <tr
          v-for="(data, index) in withdraws"
          :key="index"
        >
          <td>{{ data.amount }}</td>
          <td>
            <span
              class="badge"
              :class="{
                'badge-success': data.status === 'confirm',
                'badge-warning': data.status === 'pending',
                'badge-danger': data.status === 'fail',
              }"
            >
              {{ getStatusLabel(data.status) }}
            </span>
          </td>
          <td>{{ data.date }}</td>
          <td>
            <button
              class="btn btn-success btn-sm"
              @click="openDetail(data)"
            >
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="font-weight-bold">Total Withdraws - {{ withdrawData?.total }}</p>

    <Pagination
      align="center"
      :data="withdrawData"
      @pagination-change-page="fetchUserWithdraws"
      :limit="3"
    />

    <!-- Detail Popup -->
    <van-popup
      v-model="showDetailPopup"
      position="bottom"
      round
      closeable
      :style="{ height: 'auto', maxHeight: '80vh' }"
    >
      <div class="p-4">
        <h5 class="text-center mb-3">Withdraw Detail</h5>
        <p><strong>Amount:</strong> {{ selectedWithdraw.amount }}</p>
        <p>
          <strong>Status:</strong>
          <span
            class="badge"
            :class="{
              'badge-success': selectedWithdraw.status === 'confirm',
              'badge-warning': selectedWithdraw.status === 'pending',
              'badge-danger': selectedWithdraw.status === 'fail',
            }"
          >
            {{ getStatusLabel(selectedWithdraw.status) }}
          </span>
        </p>
        <p><strong>Date:</strong> {{ selectedWithdraw.date }}</p>
        <p v-if="selectedWithdraw.reason">
          <strong>Reason:</strong> {{ selectedWithdraw.reason }}
        </p>
      </div>
    </van-popup>
  </div>
</template>
<script>
import Pagination from "laravel-vue-pagination";
import { DateTime } from "luxon";
import { Loading } from "vant";

export default {
  components: {
    Pagination,
    Loading
  },
  data() {
    return {
      withdraws: [],
      withdrawData: {},
      isWithdrawsFetching: true,
      filters: {
        page: 1,
        perPage: 5,
        date: null,
      },
      dateOptions: [],

      showDetailPopup: false,
      selectedWithdraw: {},
    };
  },
  methods: {
    setOneMonth() {
      for (let i = 0; i < 30; i += 1) {
        const d = new Date();
        d.setHours(23, 59, 59);
        d.setDate(d.getDate() - i);
        const newObject = {};
        newObject.label = moment(d).format("l");
        newObject.data = d;
        this.dateOptions.push(newObject);
      }
    },
    openDetail(data) {
      this.selectedWithdraw = data;
      this.showDetailPopup = true;
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString("en-US", {
        timeZone: targetTimeZone,
      });
      return moment(adjustedDrawDate).format("lll");
    },
    async fetchUserWithdraws(page = 1) {
      this.isWithdrawsFetching = true;
      try {
        this.filters.page = page;
        const response = await axios.get(
          `/users/${this.$store.state.authUser.id}/withdraws`,
          {
            params: this.filters,
          }
        );
        this.withdrawData = response.data;
        this.withdraws = response.data.data;
      } catch (error) {
        this.$toast.fail("Failed!");
      } finally {
        this.isWithdrawsFetching = false;
      }
    },
    getStatusLabel(status) {
      switch (status) {
        case "confirm":
          return "အတည်ပြုပြီး";
        case "pending":
          return "လျှောက်ထားဆဲ";
        case "fail":
          return "အငြင်းခံရသည်";
        default:
          return status;
      }
    },
  },
  mounted() {
    this.setOneMonth();
    this.filters.date = moment(new Date()).format("l");
    this.fetchUserWithdraws();
  },
};
</script>

<style scoped>
tr th {
  color: #fff;
}

tr td {
  border-color: rgb(183, 170, 170);
  color: rgb(183, 170, 170) !important;
  font-weight: 700;
}

.table-custom {
  display: block;
  overflow-x: auto;
  width: 100%;
  -webkit-overflow-scrolling: touch;
}

.page-item.active .page-link {
  color: white !important;
}
</style>
